import type { FunctionComponent } from 'react';
import { FormTheme } from '@kanda-libs/ks-component-ts';

import FormPage from 'pages/ApplyForFinance/FormPage';
import BankDetailsFields from 'pages/ApplyForFinance/Pages/YourInfo/BankDetailsFields';

import useAdditionalInfoProps from './useAdditionalInfoProps';
import PersonalInformation from './PersonalInformation';
import EmploymentInformation from './EmploymentInformation';

interface AdditonaInfoFormProps {
  isSubmitting: boolean;
}

const AdditionalInfoForm: FunctionComponent<AdditonaInfoFormProps> = function ({
  isSubmitting,
}) {
  const { nextButtonProps } = useAdditionalInfoProps(isSubmitting);

  return (
    <FormPage nextButtonProps={nextButtonProps} isSubmitting={isSubmitting}>
      <FormTheme variant="streamline">
        <PersonalInformation />
        <EmploymentInformation />
        <BankDetailsFields />
      </FormTheme>
    </FormPage>
  );
};

export default AdditionalInfoForm;
